"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
const gatsby_1 = require("gatsby");
var NavLink = function NavLink(_ref) {
    var to = _ref.to, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, ["to", "className"]);
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname; // TODO: <NavLink to="/experiences" >Experiences</NavLink>
    //    should match if patch is /experiences/herpderp
    var active = pathname === to ? 'active' : '';
    return /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, Object.assign({
        className: className + " " + active
    }, {
        to: to
    }, props));
};
exports.default = NavLink;
